import { Form, Input, Select, InputNumber, Button } from "antd";
import { courierOptions } from "../../utils/shipment/courierUtils";

export const TrackingNumberForm = () => {
  return (
    <>
      <Form.Item
        label="택배사"
        name="courier_company"
        rules={[{ required: true, message: "택배사를 선택해주세요." }]}
      >
        <Select placeholder="택배사를 선택하세요" showSearch>
          {courierOptions.map((courier) => (
            <Select.Option key={courier} value={courier}>
              {courier}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="운송장번호"
        name="tracking_number"
        rules={[{ required: true, message: "운송장번호를 입력해주세요." }]}
      >
        <Input placeholder="운송장번호를 입력하세요" />
      </Form.Item>

      <Form.Item
        label="보내는 사람 이름"
        name="sender_name"
        rules={[
          { required: true, message: "보내는 사람 이름을 입력해주세요." },
        ]}
      >
        <Input placeholder="보내는 사람 이름을 입력하세요" />
      </Form.Item>

      <Form.Item
        label="보내는 사람 연락처"
        name="sender_phone"
        rules={[
          { required: true, message: "보내는 사람 연락처를 입력해주세요." },
        ]}
      >
        <Input placeholder="보내는 사람 연락처를 입력하세요" />
      </Form.Item>

      <Form.Item label="상품 정보">
        <Form.List name="products" initialValue={[{ quantity: 1 }]}>
          {(fields, { add, remove }) => (
            <>
              {fields.length === 0 && (
                <div className="mb-2 text-[#999]">상품을 추가해주세요.</div>
              )}
              {fields.map(({ key, name, ...restField }) => (
                <div key={key} className="flex gap-2 mb-2 items-start">
                  <Form.Item
                    {...restField}
                    name={[name, "product_code"]}
                    rules={[
                      { required: true, message: "상품코드를 입력해주세요." },
                    ]}
                    className="flex-1"
                  >
                    <Input placeholder="상품코드" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "product_name"]}
                    rules={[
                      { required: true, message: "상품명을 입력해주세요." },
                    ]}
                    className="flex-1"
                  >
                    <Input placeholder="상품명" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "product_option"]}
                    className="flex-1"
                  >
                    <Input placeholder="상품옵션" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "quantity"]}
                    rules={[
                      { required: true, message: "수량을 입력해주세요." },
                    ]}
                    className="w-[100px]"
                  >
                    <InputNumber
                      placeholder="수량"
                      min={1}
                      className="w-full"
                    />
                  </Form.Item>
                  <Button
                    type="link"
                    danger
                    onClick={() => remove(name)}
                    className="mt-1"
                  >
                    삭제
                  </Button>
                </div>
              ))}
              <Button
                type="dashed"
                onClick={() => add()}
                block
                className="mt-2"
              >
                + 상품 추가
              </Button>
            </>
          )}
        </Form.List>
      </Form.Item>
    </>
  );
};
